export const INBOUND_CALL_SESSION_COLLECTION_NAME = 'inboundCallSessionEvents' as const;
